import { render, staticRenderFns } from "./groupProduct.vue?vue&type=template&id=2eb01a15&scoped=true"
import script from "./groupProduct.vue?vue&type=script&lang=js"
export * from "./groupProduct.vue?vue&type=script&lang=js"
import style0 from "./groupProduct.vue?vue&type=style&index=0&id=2eb01a15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb01a15",
  null
  
)

export default component.exports